import { createReducer, on } from "@ngrx/store";
import { Company } from "../../models/company";
import { loadCompanyByIdAct, loadCompanyLogoByIdAct, loadUsersOfCompanyAct, resetCompanyAct, setViolationsCompanyAct, updateSuccessCompanyAct } from "./companies-actions";
import { User } from "../../models/user";

const company: Company = new Company();
const logoUrl: string | null = null;
const usersCompany: User[] = [];

export const companyReducer = createReducer(
    {
        company,
        violations: {},
        loading: true,
        logoUrl: null as string | null,
        usersCompany
    },
    on(resetCompanyAct, (state) => ({
        company:  { ...company },
        violations: {},
        loading: state.loading,
        logoUrl: state.logoUrl,
        usersCompany: state.usersCompany
    })),
    on(loadCompanyByIdAct, (state, { company }) => ({
        company: { ...company },
        violations: state.violations,
        loading: false,
        logoUrl: state.logoUrl,
        usersCompany: state.usersCompany
    })),
    on(loadCompanyLogoByIdAct, (state, { logoUrl }) => ({
        company: state.company,
        violations: state.violations,
        loading: false,
        logoUrl: logoUrl,
        usersCompany: state.usersCompany
    })),
    /*on(saveSuccessCompanyAct, (state, { companyNew }) => ({
        company: { ...companyNew },
        violations: {},
        loading: state.loading
    })),*/
    on(updateSuccessCompanyAct, (state, { companyUpdated }) => ({
        company: { ...companyUpdated },
        violations: {},
        loading: state.loading,
        logoUrl: state.logoUrl,
        usersCompany: state.usersCompany
    })),
    on(setViolationsCompanyAct, (state, { companyForm, violations }) => ({
        company: { ...companyForm },
        violations: {...violations},
        loading: false,
        logoUrl: state.logoUrl,
        usersCompany: state.usersCompany
    })),
    on(loadUsersOfCompanyAct, (state, { usersOfCompany }) => ({
        company: state.company,
        violations: state.violations,
        loading: false,
        logoUrl: state.logoUrl,
        usersCompany: [...usersOfCompany]
    }))
);